import { FC } from 'react';
import { GuestsCard } from 'entities/toolbar/guests/ui/components/GuestCard';
import { GuestsTitle } from '../styles';
import { Order } from 'entities/orders';
import { useAppSelector } from 'shared/lib/store';
import { selectOrdersSearchNext } from 'entities/orders/model/selectors';
import { borderRadius } from 'entities/toolbar/guests/ui/types/components';

type Props = {
    select?: (selectedId: number) => void;
    orders: Order[];
    isEmpty: boolean;
}

export const GuestsDelayedNext: FC<Props> = ({ select, orders, isEmpty }) => {
    const ordersSearch = useAppSelector(selectOrdersSearchNext);

    const hasSearchRequest = Boolean(ordersSearch.trim());
    if (isEmpty) {
        return null;
    }

    return (
        <>
            {!hasSearchRequest && <GuestsTitle $variant="danger" className='guests-title'>Опаздывают</GuestsTitle>}
            {orders.map((order, index) => {
              const borderRadius = {} as borderRadius;
              if (index === 0) {
                borderRadius.topLeft = 12;
                borderRadius.topRight = 12;
              }
              if (index === orders.length - 1) {
                borderRadius.bottomLeft = 12;
                borderRadius.bottomRight = 12;
              }
              return (<GuestsCard key={order.id} select={select} order={order} borderRadius={borderRadius} />)
            })}
        </>
    );
};
